import ScrollMagic from 'scrollmagic';

$(() => {

    const controller = new ScrollMagic.Controller();

    new ScrollMagic.Scene({
        triggerElement: '.l-page__header',
        offset: 50,
        reverse: false
    })
    .setClassToggle('.l-page__header .js-animate', 'js-animate-loaded')
    .addTo(controller);

    new ScrollMagic.Scene({
        triggerElement: '.l-page__balancing-traffic',
        triggerHook: 0.95,
        reverse: false
    })
    .setClassToggle('.l-page__balancing-traffic .js-animate', 'js-animate-loaded')
    .addTo(controller);

    new ScrollMagic.Scene({
        triggerElement: '.l-page__balancing-balancing',
        triggerHook: 0.8,
        reverse: false
    })
    .setClassToggle('.l-page__balancing-balancing .js-animate', 'js-animate-loaded')
    .addTo(controller);

    new ScrollMagic.Scene({
        triggerElement: '.l-page__balancing-other-technologies',
        triggerHook: 0.8,
        reverse: false
    })
    .setClassToggle('.l-page__balancing-other-technologies .js-animate', 'js-animate-loaded')
    .addTo(controller);

    new ScrollMagic.Scene({
        triggerElement: '.l-page__get-now',
        triggerHook: 0.8,
        reverse: false
    })
    .setClassToggle('.l-page__get-now .js-animate', 'js-animate-loaded')
    .addTo(controller);


});



// WEBPACK FOOTER //
// ./app/scripts/pages/technologies/balancing.js